import { InventoryItemGroup } from "./inventory-item-group";

export class InventorySearchResult {
  itemGroups: InventoryItemGroup[] = [];
  enableLoadMore: boolean = false;

  constructor(itemGroups: InventoryItemGroup[], enableLoadMore: boolean) {
    this.itemGroups = itemGroups;
    this.enableLoadMore = enableLoadMore;
  }
}
